// Stylized React Flow rendering of a sample login flow for the "How it works"
// section. The brief says the graph "appears here visually" — graph IS the
// artifact made literal on the landing.
//
// Read-only. No controls, no panning, no interaction. Just the picture.

import { Background, ReactFlow } from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import { useMemo } from 'react'
import { layoutFlow } from '../../lib/flow-layout.js'
import { parseFlowYaml } from '../../lib/flow-parse.js'
import { FlowNode } from '../dashboard/FlowNode.jsx'

const SAMPLE_YAML = `apiVersion: cairntools.com/v1alpha1
kind: Flow
metadata:
  name: login
spec:
  entry: home
  envs:
    dev: { url: https://example.com }
  nodes:
    home:
      title: Home
      route: /
      asserts:
        - role: heading
          text: Welcome
      transitions:
        - on: clickSignIn
          to: login
    login:
      title: Sign in
      route: /login
      asserts:
        - role: button
          text: Sign in
      transitions:
        - on: submit
          to: dashboard
    dashboard:
      title: Dashboard
      route: /dashboard
`

const nodeTypes = { flow: FlowNode }

export function HowItWorksGraph() {
  const { nodes, edges } = useMemo(() => {
    const parsed = parseFlowYaml(SAMPLE_YAML)
    const laid = layoutFlow(parsed.nodes, parsed.edges)
    return {
      nodes: laid.nodes.map((n) => ({ ...n, type: 'flow' })),
      edges: laid.edges.map((e) => ({
        ...e,
        type: 'smoothstep',
        style: { stroke: 'oklch(60% 0.008 60)', strokeWidth: 1.5 },
        labelStyle: { fill: 'oklch(30% 0.008 60)', fontSize: 11 },
      })),
    }
  }, [])

  return (
    <div className="h-[460px] w-full overflow-hidden rounded-md border border-[var(--color-sandstone)] bg-[var(--color-limestone)]">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        fitView
        fitViewOptions={{ padding: 0.2 }}
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
        zoomOnScroll={false}
        panOnScroll={false}
        panOnDrag={false}
        zoomOnDoubleClick={false}
        zoomOnPinch={false}
        proOptions={{ hideAttribution: true }}
      >
        <Background color="oklch(92% 0.008 60)" gap={16} />
      </ReactFlow>
    </div>
  )
}
